var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 17,
    fill: "none",
    viewBox: "0 0 6 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75787B",
    d: "M3.848.224A1.33 1.33 0 0 0 2.604.098a1.32 1.32 0 0 0-.82 1.22A1.326 1.326 0 1 0 3.849.225M1.043 3.072c.206-.086.428-.13.652-.13h2.796A1.726 1.726 0 0 1 6.197 4.68V8.72a.573.573 0 0 1-1.147 0V5.006h-.269v10.176a.773.773 0 1 1-1.546 0V9.28h-.263v5.903a.773.773 0 1 1-1.54 0V5.006h-.276V8.72a.58.58 0 1 1-1.153 0V4.653a1.69 1.69 0 0 1 1.04-1.581"
  })));
};
export default SvgPerson;